'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
	autoFocus: _propTypes2.default.bool,
	children: _propTypes2.default.node,
	className: _propTypes2.default.string,
	defaultValue: _propTypes2.default.any,
	disabled: _propTypes2.default.bool,
	errorStyle: _propTypes2.default.object,
	errorText: _propTypes2.default.node,
	floatingLabelFixed: _propTypes2.default.bool,
	floatingLabelFocusStyle: _propTypes2.default.object,
	floatingLabelStyle: _propTypes2.default.object,
	floatingLabelText: _propTypes2.default.node,
	fullWidth: _propTypes2.default.bool,
	hintStyle: _propTypes2.default.object,
	hintText: _propTypes2.default.node,
	id: _propTypes2.default.string,
	inputStyle: _propTypes2.default.object,
	multiLine: _propTypes2.default.bool,
	name: _propTypes2.default.string,
	onBlur: _propTypes2.default.func,
	onChange: _propTypes2.default.func,
	onFocus: _propTypes2.default.func,
	onKeyDown: _propTypes2.default.func,
	rows: _propTypes2.default.number,
	rowsMax: _propTypes2.default.number,
	style: _propTypes2.default.object,
	textareaStyle: _propTypes2.default.object,
	type: _propTypes2.default.string,
	underlineDisabledStyle: _propTypes2.default.object,
	underlineFocusStyle: _propTypes2.default.object,
	underlineShow: _propTypes2.default.bool,
	underlineStyle: _propTypes2.default.object,
	value: _propTypes2.default.any
};

var WMTextField = function WMTextField(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_TextField2.default, props)
	);
};

exports.default = WMTextField;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTextField/index.js